import React from 'react'
import { Icon } from 'loyal-react'

const redirectLogin = () => {
  window.location.href = '/auth/login'
}

const GuestUserProfile = () => (
  <li className='px-1 h-auto border-color-ui-3 border-bottom bg-brand-2 mb-1'>
    <div className='row align-items-center h-100 pos-relative'>
      <button
        onClick={() => redirectLogin()}
        className='btn btn-sm btn-double btn-flat btn-icon txt-font-body txt-initial txt-body txt-left py-1'
        role='button'
      >
        <Icon iconName='icon_profile color-ui-white' />
        <p className='txt-body-sm color-ui-white'>Olá, faça o seu login</p>
        <strong className='txt-body-sm color-brand-6'>ou cadastre-se</strong>
      </button>
    </div>
  </li>
)

export default GuestUserProfile



// WEBPACK FOOTER //
// ./src/App/Header/GuestHeader/GuestUserProfileMobile.js